@if (iaChatbotUrl != null && chatBotVisible) {
    <div id="chatbot-launcher">
        <div class="chatbot-message transition">
            <div [className]="'close-message close-message-'+environment.data.brand">+</div>
            <p id="welcome" class="transition">Comment puis-je vous aider ?</p>
            <div [className]="'open-chatbot open-chatbot-'+environment.data.brand">
                <span id="unread-number">&nbsp;</span>
            </div>
        </div>
        <div id="close-chatbot-desktop" [className]="'close-chatbot close-chatbot-'+environment.data.brand">+</div>
    </div>
}

@if (iaChatbotUrl != null && chatBotVisible) {
    <div
            id="chatbot-wrapper"
            [className]="'transition chatbot-wrapper-background-'+environment.data.brand"
    >
        <div id="close-top" [className]="'close-chatbot close-chatbot-'+environment.data.brand">
            <button type="button">X</button>
        </div>
        <iframe id="chatbot-frame" [src]="iaChatbotUrl" referrerpolicy="strict-origin">&nbsp;</iframe>
    </div>
}
